<template>
  <v-container fluid fill-height class="background-grey">
    <setup-checklist-stepper
      v-if="currentStep"
      :step="currentStep"
      @currentStepIncrement="currentStepIncrement"
      @currentStepDecrement="currentStepDecrement"
      @setStep="setStep"
    />
  </v-container>
</template>

<script>
  import SetupChecklistStepper from './SetupChecklistStepper'
  import SetupChecklistFinal from './SetupChecklistFinal'
  export default {
    name: 'GettingStartedPreview',
    components: {SetupChecklistStepper, SetupChecklistFinal},
    data () {
      return {
        currentStepNumber: 1,
        steps: [
          {
            id: 1,
            image: 'create-new-campaign.png',
            text: 'It\'s easy to create your first campaign!'
          },
          {
            id: 2,
            image: 'messages.png',
            text: 'You can upload your own creative or let us help you design new assets.'
          },
          {
            id: 3,
            image: 'reporting.png',
            text: 'You can review easy to understand analytics and reporting.'
          }
        ]
      }
    },
    computed: {
      currentStep () {
        return this.steps.find(step => step.id === this.currentStepNumber)
      }
    },
    methods: {
      currentStepDecrement () {
        if (this.currentStepNumber > 1) this.currentStepNumber--
      },
      currentStepIncrement () {
        if (this.currentStepNumber < 3) return this.currentStepNumber++
        else this.$router.push('/setup-checklist/1/define-key-campaign-dates')
      },
      setStep (step) {
        this.currentStepNumber = step
      }
    }
  }
</script>
